// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3szVg","unreadBadge":"styles_unreadBadge__3b66D","modalContent":"styles_modalContent__1yYrb","modal":"styles_modal__1IAvA"};